import React from 'react';

const StoreMap = () => {
  // Using Google Maps Embed with a general New York City location
  // Address: 123 Pet Street, Animal City (example coordinates: Times Square, NYC)
  const mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.2412648718453!2d-73.98823492346644!3d40.75889713573952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25855c6480299%3A0x55194ec5a1ae072e!2sTimes%20Square!5e0!3m2!1sen!2sus!4v1699999999999!5m2!1sen!2sus";

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', borderRadius: '12px', overflow: 'hidden' }}>
      <iframe
        title="FocoPet Store Location"
        src={mapEmbedUrl}
        width="100%"
        height="100%"
        style={{ border: 0, borderRadius: '12px' }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
      
      {/* Optional: Add a custom marker overlay */}
      <div 
        style={{
          position: 'absolute',
          top: '10px',
          left: '10px',
          backgroundColor: 'white',
          padding: '8px 12px',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          fontSize: '14px',
          fontWeight: 'bold',
          color: '#a5cb89',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <img 
          src="https://customer-assets.emergentagent.com/job_modern-bs5-site/artifacts/eelqdwqk_ChatGPT%20Image%20Nov%2010%2C%202025%2C%2011_44_19%20PM.png" 
          alt="FURRMAA Logo" 
          style={{ height: '20px', width: 'auto', marginRight: '8px' }}
        />
        FURRMAA Store
      </div>
    </div>
  );
};

export default StoreMap;
